define('modules/login/module',[
	"modules/login/routes",
	"modules/login/controller/Login",
	"modules/login/controller/ModalAppSecurity",
	"modules/login/service/Auth",
	"modules/login/service/CredenzialiUtente",
], function(
	Routes,
	LoginController,
	ModalAppSecurityController,
	Auth,
	CredenzialiUtente) {
	"use strict";
	var MODULE_NAME = "Login";
	angular.module(MODULE_NAME, ["Common", "ui.bootstrap"])
		.service("Auth", Auth)
		.service("CredenzialiUtente", CredenzialiUtente)
		.controller("LoginController", LoginController)
		.controller("ModalAppSecurityController", ModalAppSecurityController)
		.config(Routes);
	return MODULE_NAME;
});
